import * as React from "react";
const SvgArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M21.4038 2.59464C21.0341 2.21696 20.5359 2 20.0056 2C19.4752 2 18.977 2.21696 18.6073 2.59464L5.10734 16.7375C4.36805 17.5089 4.4002 18.7304 5.17163 19.4616C5.94305 20.1929 7.16448 20.1687 7.89573 19.3973L18.077 8.74196V36.0714C18.077 37.1402 18.9368 38 20.0056 38C21.0743 38 21.9341 37.1402 21.9341 36.0714V8.74196L32.1073 19.4054C32.8466 20.1768 34.06 20.2009 34.8314 19.4696C35.6029 18.7384 35.627 17.517 34.8957 16.7455L21.3957 2.60268L21.4038 2.59464Z" }));
export default SvgArrowUp;
